import React from "react";
import { DatePicker, DatePickerProps } from "antd";
import { DefaultFormatDateTime } from "../../../enums";

interface IProps extends DatePickerProps
{
  className?: string;
  label?: string;
  required?: boolean;
}

export default function DatePickerUI({
  className,
  format = DefaultFormatDateTime.DATE_FORMAT,
  label,
  required,
  ...res
}: IProps)
{
  return (
    <>
      {label && (
        <p className="mb-2 text-[var(--color-label-form)] text-sm">
          {label}
          {required && <span className="text-common-red500">{` *`}</span>}
        </p>
      )}
      <DatePicker
        {...res}
        format={format}
        variant="filled"
        className={`border-0 h-[34px] rounded-[2px] !shadow-none  ${className ? " " + className : ""
          } `}
      ></DatePicker>
    </>
  );
}
